<template>
  <div class="p-2">
    <!-- Price Filter Slider -->
    <div class="container grid grid-cols-1 mx-auto mb-6">

      <label for="dealer" class="block text-base font-bold text-gray-700">Filter by Dealer:</label>
      <div class="flex flex-row relative w-full justify-center items-center">
      <div class="items-center m-2" v-for="(sale, index) in uniqueSales" :key="index">      
        <input
              :id="'checkbox-' + index"
              type="checkbox"
              v-model="selectedSales"
              :value="sale"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              :for="'checkbox-' + index"
              class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              {{ sale }}
            </label>
      </div>
    </div>
<!--
      <label for="age" class="block text-base font-bold text-gray-700">Filter new or old:</label>
      <div class="flex flex-row relative w-full justify-center items-center">
      <div class="items-center m-2" v-for="(age, index) in uniqueAge" :key="index">      
        <input
              :id="'checkbox-' + index"
              type="checkbox"
              v-model="selectedAges"
              :value="age"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              :for="'checkbox-' + index"
              class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              {{ age }}
            </label>
      </div>
</div>
-->
<label for="brands" class="block text-base font-bold text-gray-700">Filter by brand:</label>
<div class="flex flex-wrap w-full justify-start">
  <div class="flex items-center m-2" v-for="(brand, index) in uniqueBrands" :key="index">
    <input
      :id="'brand-checkbox-' + index"
      type="checkbox"
      v-model="selectedBrands"
      :value="brand"
      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
    />
    <label
      :for="'brand-checkbox-' + index"
      class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
    >
      {{ brand }}
    </label>
  </div>
</div>




      <label for="priceRange" class="block text-base font-bold text-gray-700">Filter by Price:</label>
      <div class="flex items-center space-x-4">
        <!-- Display min price -->
        <span class="text-gray-500">{{ formatNumber(priceRange[0]) }}</span>
        <div class="relative w-full">
          <!-- Slider Component -->
          <label for="minmax-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Min-max range
          </label>
          <VueSlider :min="chosenminprice" :max="chosenmaxprice" v-model="chosenprices" />
          <span>Chosen Price: {{ formatNumber(chosenprices[0]) }} - {{ formatNumber(chosenprices[1]) }}</span>
        </div>

        <!-- Display max price -->
        <span class="text-gray-500">{{ formatNumber(priceRange[1]) }}</span>
      </div>
    </div>

    <!-- Cars Grid -->
    <div class="container mx-auto">
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div v-for="car in filteredCars" :key="car.id">
          <carcard
            :title="car.title"
            :price="car.price"
            :sale="car.sale"
            :imagesrc="car.image"
            :link="car.link"
            :attributes="car.attributes"
          ></carcard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import carcard from './carcard.vue';
import VueSlider from 'vue-3-slider-component';

export default {
  name: 'NewCars',
  components: { carcard, VueSlider },
  props: {
    page: {
      type: String,
      required: false,
      default: 'New', // Default value if no prop is passed
    },
  },
  data() {
    return {
      password: 'maggibest',
      cars: [], // Car data fetched from API
      priceRange: [0, 100000], // Default price range [low, high]
      minPrice: 0,
      maxPrice: 100000,
      chosenminprice: 0,
      chosenmaxprice: 0,
      chosenprices: [0, 0], // Price range selected by slider
      selectedSales: [], // Selected sales checkboxes
      selectedAges: [],
      selectedBrands: [],
    };
  },
  computed: {
    uniqueSales() {
      return [...new Set(this.cars.map((car) => car.sale))];
    },
    uniqueAge() {
      return [...new Set(this.cars.map((car) => car.age))];
    },
    uniqueBrands() {
      return [...new Set(this.cars.map((car) => car.title.split(" ")[0]))];
    },
    filteredCars() {
      return this.cars.filter(
        (car) =>
          car.price >= this.chosenprices[0] &&
          car.price <= this.chosenprices[1] &&
          (this.selectedSales.length === 0 || this.selectedSales.includes(car.sale)) &&
          (this.selectedAges.length === 0 || this.selectedAges.includes(car.age)) &&
          (this.selectedBrands.length === 0 ||
            this.selectedBrands.includes(car.title.split(" ")[0]))
      );
    },
  },
  methods: {
    async getcars(page) {
      const url = `cars`;
      const url2 = `${url}/${page}`;
      try {
        const response = await axios.get(url2);
        this.cars = response.data;

        if (this.cars.length > 0) {
          this.minPrice = Math.min(...this.cars.map((car) => car.price));
          this.maxPrice = Math.max(...this.cars.map((car) => car.price));
          this.priceRange = [this.minPrice, this.maxPrice];
          this.chosenminprice = this.minPrice;
          this.chosenmaxprice = this.maxPrice;
          this.chosenprices = [this.chosenminprice, this.chosenmaxprice];
        }
      } catch (error) {
        console.error('Error fetching cars:', error);
      }
    },
    formatNumber(num) {
      return parseInt(num).toLocaleString('de-DE');
    },
  },



  async mounted() {
    // Use the passed prop `page` for initial data fetch
    this.getcars(this.page);
  },
  
  watch: {
    page: {
      immediate: true,
      handler(newPage) {
        this.getcars(newPage); // Fetch data when the prop changes
      },
    },
  },

};
</script>

